import React from 'react';

import { node, bool, string, oneOfType, arrayOf } from 'prop-types';

import BaseComponent from '../../.internal/BaseComponent';

import './SelectOptionGroup.scss';

/**
 * @deprecated
 */
export default class SelectOptionGroup extends BaseComponent {
  render() {
    const { label, children } = this.props;

    return (
      <li className="SelectOptionGroup">
        <p className="group-label">{label}</p>
        <ul className="group-list">{children}</ul>
      </li>
    );
  }
}

SelectOptionGroup.propTypes = {
  children: oneOfType([arrayOf(node), node]),
  disabled: bool,
  label: string
};

SelectOptionGroup.defaultProps = {
  children: undefined,
  disabled: false,
  label: ''
};
